import { render, staticRenderFns } from "./UserDay.vue?vue&type=template&id=71b2dbbc&scoped=true&"
import script from "./UserDay.vue?vue&type=script&lang=js&"
export * from "./UserDay.vue?vue&type=script&lang=js&"
import style0 from "./UserDay.vue?vue&type=style&index=0&id=71b2dbbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b2dbbc",
  null
  
)

export default component.exports